import { render, staticRenderFns } from "./PrintPatientSideCard.vue?vue&type=template&id=43e2f240&"
import script from "./PrintPatientSideCard.vue?vue&type=script&lang=js&"
export * from "./PrintPatientSideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports